import type { BossStatus } from '../../core/boss/boss-fight';

/**
 * Animation of JEFE-3 El Padrinito from the state of the core (GDD §9.2, issue #122), as a pure function: the render only
 * reads the fight. Priority: the retreat (the balloon deflates), the flour reaction to a decoy hit, the stagger of the phase
 * transition, then what the phase asks of him: the check (the last phase), the dialling (the calls) and the phone at the
 * ear (the plazas).
 */
export type Jefe3Animation = 'ON_THE_PHONE' | 'DIALING' | 'FLOUR_HIT' | 'STAGGER' | 'CHECK' | 'DEFLATE';

/** The phone he holds, and what the capo does with his hands while he argues in the retreat. */
export type PhoneAnimation = 'IDLE' | 'RING';
export type CapoAnimation = 'TALKING' | 'ARGUING';

/** How long the flour reaction lasts and how long the phone rings after the core rings it, in ticks. */
export const FLOUR_TICKS = 40;
export const RING_TICKS = 70;

export interface Jefe3Input {
  status: BossStatus;
  phaseName: string;
  ticksSinceHit: number | null;
  ticksSinceRing: number | null;
}

export function jefe3Animation(input: Jefe3Input): Jefe3Animation {
  if (input.status === 'retreating' || input.status === 'done') return 'DEFLATE';
  if (input.ticksSinceHit !== null && input.ticksSinceHit < FLOUR_TICKS) return 'FLOUR_HIT';
  if (input.status === 'transition') return 'STAGGER';
  if (input.phaseName === 'JAQUE') return 'CHECK';
  if (input.phaseName === 'LLAMADAS') return 'DIALING';
  return 'ON_THE_PHONE';
}

/** The phone rings for 1.0 s or more after the ring of the core (the warning of the call). */
export const phoneAnimation = (ticksSinceRing: number | null): PhoneAnimation => (ticksSinceRing !== null && ticksSinceRing < RING_TICKS ? 'RING' : 'IDLE');

/** The capo argues in the retreat and talks otherwise. */
export const capoAnimation = (status: BossStatus): CapoAnimation => (status === 'retreating' || status === 'done' ? 'ARGUING' : 'TALKING');

/** Scale of the balloon during the retreat: it loses air from 1 to this fraction. */
export const DEFLATED_SCALE = 0.45;
export const balloonScale = (retreatProgress: number): number => 1 - (1 - DEFLATED_SCALE) * Math.min(1, Math.max(0, retreatProgress));
